export enum OrderOrShipmentTemplateAction {
  DELETE = 'DELETE',
  DISCARD_CHANGES = 'DISCARD_CHANGES',
  RENAME = 'RENAME',
  SAVE = 'SAVE',
  SAVE_AS = 'SAVE_AS',
  SET_DEFAULT = 'SET_DEFAULT',
  REMOVE_DEFAULT = 'REMOVE_DEFAULT',
}
